export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.tags': '标签管理',
  'menu.comics': '漫画管理',
  'menu.comics.list': '漫画列表',
  'menu.comics.recommended': '首页推荐',
  'menu.comics.create': '新建漫画',
  'menu.comics.edit': '编辑漫画',
  'menu.comics.chapters': '章节管理',
  'menu.comics.chapterEdit': '编辑章节',
  'menu.logs': '黑名单记录',
  'menu.logs.blacklist': '黑名单记录',
  'menu.logs.whitelist': '白名单列表',
  'menu.logs.accessLog': '访问记录',
  'menu.logs.sourceDevices': '渠道设备',
  'menu.auditConfig': '版本管理',
  'menu.growthConfig': '增长配置',
  'menu.applications': '应用管理',
  'menu.apple-subscriptions': 'Apple订阅管理',
  'menu.console': '控制台',
  'menu.gray-routes': '灰度路由',
  'menu.apple-notification-logs': 'Apple原始通知',
  'menu.apple-event-rules': 'Apple事件规则',
  'menu.platform-dispatch-logs': '平台上报记录',
  'menu.client-request-logs': '客户端请求日志',
  'menu.apple-notification-simulator': '模拟器',
  'menu.console.gray-routes': '灰度路由',
  'menu.console.apple-notification-logs': 'Apple原始通知',
  'menu.console.apple-event-rules': 'Apple事件规则',
  'menu.console.platform-dispatch-logs': '平台上报记录',
  'menu.console.client-request-logs': '客户端请求日志',
  'menu.console.apple-notification-simulator': '模拟器',
  'menu.proxy-services': '代理管理',
  'menu.currency-rates': '汇率管理',
};
